import { EventBus } from './event-bus';

export const EventBusSingleton = (function () {
    let instance = null;

    function createInstance() {
        const eventBus = new EventBus();
        return eventBus;
    }

    return {
        getInstance: function () {
            if (!instance) {
                instance = createInstance();
            }
            return instance;
        }
    };
})();